import { LoadingButton } from '@mui/lab';
import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Transition } from '../../../components/Transition';
import { WALLET_PAYMENT_METHOD } from '../../../constants';

interface IProps {
  toggle: boolean;
  onClose: () => void;
  values: any;
  handleSubmit: () => void;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => Promise<any>;
  handleChange: (e: React.ChangeEvent<any>) => void;
  errors: any;
  touched: any;
  isSubmitting: boolean;
  resetForm: () => void;
  currentBalance?: number;
}

const WalletTransactionFormModal: React.FC<IProps> = ({
  toggle,
  onClose,
  errors,
  touched,
  values,
  isSubmitting,
  setFieldValue,
  handleChange,
  handleSubmit,
  resetForm,
  currentBalance = 0,
}) => {
  const isReduce = values.paymentMethod === 'reduceNote';

  return (
    <Dialog
      fullWidth
      open={toggle}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => {
        resetForm();
        onClose();
      }}
      aria-describedby='alert-dialog-slide-description'
      key={`uf`}
    >
      <DialogTitle sx={{ mt: -0.5, mb: -0.5 }}>Edit Wallet Credit</DialogTitle>
      <form
        onSubmit={handleSubmit}
        autoComplete='off'
      >
        <DialogContent dividers>
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={12}
            >
              <Typography variant='body2'>
                Total Credit: <strong>{currentBalance}</strong>
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
            >
              <TextField
                id='amount'
                name='amount'
                label={isReduce ? 'Reduce Amount' : 'Add Amount'}
                type='number'
                fullWidth
                variant='outlined'
                onChange={handleChange}
                value={values.amount}
                error={Boolean(errors.amount && touched.amount)}
                helperText={
                  Boolean(errors.amount && touched.amount) && errors.amount
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
            >
              <FormControl
                fullWidth
                error={Boolean(touched.paymentMethod && errors.paymentMethod)}
              >
                <InputLabel>Select Payment Method</InputLabel>
                <Select
                  id='paymentMethod'
                  name='paymentMethod'
                  value={values.paymentMethod}
                  onChange={(e) => {
                    setFieldValue('paymentMethod', e.target.value);
                    setFieldValue(
                      'cdType',
                      e.target.value === 'reduceNote' ? 'D' : 'C'
                    );
                  }}
                  label='Select Payment Method'
                >
                  {WALLET_PAYMENT_METHOD.map((method) => {
                    return (
                      <MenuItem
                        key={method?.value}
                        value={method?.value}
                      >
                        {method?.name}
                      </MenuItem>
                    );
                  })}
                </Select>
                {Boolean(touched.paymentMethod && errors.paymentMethod) && (
                  <FormHelperText>{errors.paymentMethod ?? ''}</FormHelperText>
                )}
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              resetForm();
              onClose();
            }}
            variant='outlined'
          >
            {'Cancel'}
          </Button>
          <LoadingButton
            type='submit'
            loading={isSubmitting}
            variant='contained'
          >
            {'Save'}
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default WalletTransactionFormModal;
